import React from 'react';
import Badge from '../../common2/Badge';
import { DorStatus } from '../../../api/types';

const dorStatusTitleIntent = {
  [DorStatus.PENDING]: {
    intent: 'warning',
    title: 'Pending',
  },
  [DorStatus.COMPLETED]: {
    intent: 'positive',
    title: 'Signed',
  },
  [DorStatus.REJECTED]: {
    intent: 'alert',
    title: 'Rejected',
  },
  [DorStatus.EXPIRED]: {
    intent: 'alert',
    title: 'Expired',
  },
};

function DorStatusBadge({ dorStatus }: { dorStatus: DorStatus | null }) {
  if (!dorStatus) {
    return null;
  }

  const dorStatusBadgeData = dorStatusTitleIntent[dorStatus];
  return <Badge intent={dorStatusBadgeData.intent}>{dorStatusBadgeData.title}</Badge>;
}

export default React.memo(DorStatusBadge);
